import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@locus-taxy/encore-mui';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { getTestId } from '@locus-taxy/encore-utils';
import { TestIdAction } from '../../utils/testIdUtils';

interface UnsavedChangesDialogProps {
  readonly open: boolean;
  readonly onStay: () => void;
  readonly onLeave: () => void;
}

export function UnsavedChangesDialog({
  open,
  onStay,
  onLeave,
}: UnsavedChangesDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onStay}
      maxWidth="sm"
      fullWidth
      data-testid={getTestId({ action: TestIdAction.VIEW, object: 'unsaved-changes-dialog', page: 'account' })}
    >
      <DialogTitle>
        {t('userDetails.unsavedChangesTitle', 'Unsaved Changes')}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" color="text.secondary">
          {t(
            'userDetails.unsavedChangesBody',
            'You have unsaved changes. If you leave this page, your changes will be lost.'
          )}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          size="large"
          color="inherit"
          onClick={onStay}
          data-testid={getTestId({ action: TestIdAction.VIEW, object: 'stay-on-page-button', page: 'account' })}
        >
          {t('userDetails.stayOnPage', 'Stay on Page')}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="error"
          onClick={onLeave}
          data-testid={getTestId({ action: TestIdAction.VIEW, object: 'leave-page-button', page: 'account' })}
        >
          {t('userDetails.leavePage', 'Leave Page')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
